/// <amd-module name="typeahead/core/IListItem"/>
export enum ListItemType {Label, Suggestion}

export interface IListItem {
    listItemType: ListItemType;
}

export class LabelTypeListItem implements IListItem {

    public readonly listItemType: ListItemType = ListItemType.Label;
    constructor (public html: string) {}
}
